import { CommonService } from './helpers/common.service';
import { Component, OnInit } from '@angular/core';
import { AuthService } from './auth.service';
import { Router } from '@angular/router';
import {
  MatDialog,
} from '@angular/material/dialog';
import { ICategories } from './components/dashboard/dashboard.model';

interface Organization {
  value: string;
  viewValue: string;
}

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {

  title = 'dashboards';
  token: string | null = null;
  user: string | null = null;
  companyOrg: string | null = null;
  companyId: number;
 categories: ICategories[] = [];  // Replace with actual categories
  loginCompany: string | null;

  constructor(private authService: AuthService, private router: Router, private dialog: MatDialog,
    private commonService: CommonService
  ) { }

  selectedValue: Organization = { value: '0', viewValue: 'Select' };
  organizations: Organization[] = [];

  ngOnInit() {
    this.checkAuthToken();
    if(this.checkAuthToken().token) {
      this.getSelectedComopnayDashboard();
      const companyIdval = localStorage.getItem('companyId') ? localStorage.getItem('companyId') : localStorage.getItem('company');
    this.companyId = companyIdval ? Number.parseInt(companyIdval, 10) : 0;
    this.loginCompany = localStorage.getItem('company');
    this.getCategories();
    }
  }

  checkAuthToken() {
    this.token = this.authService.getToken();  // Fetch the token on load
    this.user = localStorage.getItem('userName');
    this.companyOrg = localStorage.getItem('companyOrg');
    return {
      token: this.token,
      companyOrg: this.companyOrg
    };
  }

  getSelectedComopnayDashboard() {
    this.authService.getDashboardScreenByOrg().subscribe((response) => {
      if(response && Array.isArray(response.value)){
        const data = response.value;
        this.organizations = [
          // { value: '0', viewValue: 'Select' }, // Not needed as default value
          ...data.map((org: any) => ({
            value: org.id.toString(),
            viewValue: org.name.toUpperCase()
          }))
        ];
        const selectedOrgValue = localStorage.getItem('companyId');
        const parsedOrg = JSON.parse(selectedOrgValue!);
        const selectedOrg = this.organizations.find(org => org.value === parsedOrg.toString());
        this.selectedValue = selectedOrg ? selectedOrg : { value: '0', viewValue: 'Select' };
      } else {
        this.organizations = [{ value: '0', viewValue: 'Select' }];
      }
    });
  }

  logout() {
    this.authService.logout();
    this.token = null;
    // Redirect to login page after logout
    this.router.navigate(['/login']).then(() => {
      // Reload the page to refresh all components
      window.location.reload();
    });
  }

  viewProfile() {
    this.router.navigate(['/components/dashboard']);
  }


  getCategories() {
    this.commonService.getCategories(this.companyId).subscribe({
      next: (response) => {
        if(response){
          this.categories = Array.isArray(response) ? response : Object.keys(response);
          // Pass the categories to the child component using a service or an alternative way
            this.commonService.allCategories$.next(this.categories);
        }
      },
      error: (error) => {
      },
    });
  }

  changeOrganization(id: string) {
    localStorage.setItem('companyId', id);
    this.companyId = Number.parseInt(id, 10);
    this.getCategories();
    window.location.reload();
    const selectedOrg = this.organizations.find(org => org.value === this.companyId.toString());
    this.selectedValue = selectedOrg ? selectedOrg : { value: '0', viewValue: 'Select' };
  }

}
